import { render, staticRenderFns } from "./MakeWriting.vue?vue&type=template&id=2158de9f&scoped=true"
import script from "./MakeWriting.vue?vue&type=script&lang=js"
export * from "./MakeWriting.vue?vue&type=script&lang=js"
import style0 from "./MakeWriting.vue?vue&type=style&index=0&id=2158de9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158de9f",
  null
  
)

export default component.exports